// extracted by mini-css-extract-plugin
export default {"textarea":"FeedbackModal_textarea__sMMWV"};